import { gql } from '@apollo/client';

export default gql`
  mutation CheckoutTickets($ticketNumbers: [String!], $bookingReference: String!) {
    checkoutTickets(ticketNumbers: $ticketNumbers, bookingReference: $bookingReference) {
      reference
    }
  }
`;
